import styles from "./styles.module.css";
import iLogo from "./logo.png";
import video from "./animace.webm";

export const Header = () => {
  return (
    <header className={styles.header}>
      <video
        autoPlay={true}
        controls={false}
        loop={true}
        muted={true}
        className={styles.video}
      >
        <source src={video} type="video/webm" />
      </video>
      <img src={iLogo} className={styles.iLogo} alt="Gaming Heroes logo" />
    </header>
  );
};
